<template>
  <div class="product-container" v-if="item">
    <div class="bestDeal body-2" v-if="item.isBestDeal">BEST DEAL</div>
    <v-row justify="space-between" align-content="center" style="margin: 0">
      <v-col cols="8" class="py-4 order-0" xs="8" sm="8" ml="3" lg="3">
        <div class="d-flex flex-lg-column align-center align-lg-start align-xl-start cardComp">
          <div class="logo-container">
            <v-img style="max-height: 30px; max-width: 100px;" :src="require(`@/assets/platformlogo/${item.issuer || item.issuers}.png`)" />
          </div>
          <span class="black--text title-2">{{item.honeyLemon_contract_name || item.name || `${item.id.split('-')[0]}-${item.coin}`}}</span>
        </div>
      </v-col>

      <v-col cols="6" class="d-flex align-lg-center order-2 order-lg-1  flex-column flex-md-row" xs="4" ml="2" lg="2">
        <span class="dealMeta">Unit Cost</span>
        <div class="black--text body-1 d-flex align-center">
          <slot name="s1" :item="item" :currency="currency" />
          <v-tooltip right max-width="400px">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on" @click.stop class="body-1 ml-1">mdi-help-circle-outline</v-icon>
            </template>
            <span>
            Note: sum of upfront fees and present value of expected future cashflow earned over duration of the contract,
            discounted with CeFi/DeFi interest rate (See Messari), divided into unit cost (BTC: $ per Th per Day, or ETH: $ per Mh per Day)
          </span>
          </v-tooltip>
        </div>
      </v-col>

      <v-col cols="4" class="d-flex align-center order-1 order-lg-2" xs="4" ml="2" lg="2">
        <div style="display: block;" class="title-2 font-weight-normal flex-grow-1 text-right mr-2">
          <span v-if="item.size">Min {{item.size / blockchain[item.coin].unitFactor}}{{blockchain[item.coin].unit}}</span>
        </div>
      </v-col>

      <v-col cols="2" class="d-flex order-3" style="padding-top: 0; padding-bottom: 0;"  xs="4" ml="2" lg="2">
        <div class="d-flex discount align-lg-center d-flex align-center">
          <div class="d-flex discount flex-column align-self-center">
            <slot name="s2" :item="item" :currency="currency" />
          </div>
        </div>
        <v-tooltip top max-width="400px" class="ml-2">
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" @click.stop class="body-1 mx-1">mdi-help-circle-outline</v-icon>
          </template>
          Note: Discount calculated as the cost of buying {{item.coin}} compared to {{item.coin}} earned via buying the cloud mining contract.
          The {{item.coin}} earned via contract is calculated based on static projection of theoretical mining payoff given network difficulty and coin price at the moment
        </v-tooltip>
      </v-col>

      <v-col cols="4" class="d-flex align-center order-4"  xs="2" ml="3" lg="3">
        <v-btn text icon color="black" @click.stop="toggleFavorites(item.id)" class="mr-2">
          <v-icon v-if="favorites.indexOf(item.id) < 0">mdi-heart-outline</v-icon>
          <v-icon v-if="favorites.indexOf(item.id) >= 0" color="red">mdi-heart</v-icon>
        </v-btn>
        <v-btn
                @click.stop="window.fbq('trackCustom', 'check-it-out', { id: item.id, coin: item.coin }) | $gtag.event(item.coin, { event_category: 'check-it-out', event_label: item.id })"
                :href="item.buy_url || item.url"
                target="_blank"
                color="white"
                class="check-btn"
        >
          <v-img
                  alt="Honey Lemon Logo"
                  class="logoCheck"
                  contain
                  :src="require('@/assets/deal.svg')"
                  width="20"
          />
          <span class="ml-2">Check it out</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>

</template>

<script>
import { mapState } from "vuex";

import { price, percent, unit } from "../../filters";

export default {
  name: "Product",
  props: ["item"],
  filters: { price, percent, unit },
  computed: {
    ...mapState(["favorites", "blockchain"]),
    ...mapState("product", ["currency"])
  },
  methods: {
    toggleFavorites(id) {
      this.$gtag.event("toggle-favorites", {event_label: id});
      this.$store.commit("toggleFavorites", id);
    }
  },
  data() {
    return { window };
  }
}
</script>

<style scoped lang="scss">
.product-container {
  position: relative;
}

.bestDeal {
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  background: #13b7bd;
  padding: 2px 10px;
  color: white;
  border-radius: 0 !important;
  font-weight: 500;
}

.check-btn {
  span {
    @media (max-width: 800px) {
      display: none;
    }
  }
  @media (max-width: 800px) {
    background: white !important;
    color: black !important;
    min-width: 40px !important;
    width: 40px !important;
    height: 40px !important;
    box-shadow: none;
  }
}

.dealData {
  //headline font-weight-medium black--text
  font-weight: 500;
  font-size: 18px;
  color: #333;
}

.dealMeta{
  display: none;
  @media (max-width: 500px) {
    display: block;
    font-size:12px;
    text-align: left;
    font-weight: 300;
    color: #333;
  }
}

.logo-container {
  width: 120px;
}

@media only screen and (max-width: 500px) {
  .caption,
  .min-text {
    text-align: left;
  }
  .title-2{
    font-size: 14px !important;
  }
  .subtitle-1{
    font-size: 12px !important;
    font-weight: 400;
  }
  .body-1{
    font-size: 14px !important;
  }

  .dealData {
    margin-right: 0 !important;
    text-align: left;
  }

  .mdi-help-circle-outline {
    display: none;
  }

  .logo-container {
    width: 100px;
  }

  .cardComp img{
    max-width: 100px !important;
  }
  .cardComp span{
    margin-left: -10px !important;
    font-weight: 500;
    font-size: 14px;
  }
}

.v-item--active {
  color: #222;
  background-color: #ffe500 !important;
}

.v-card--hover:hover {
  -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 229, 0, 0.8),
  0px 2px 2px 2px rgba(251, 255, 0, 0.2);
  box-shadow: 0px 0px 0px 2px rgba(255, 229, 0, 0.8),
  0px 2px 2px 2px rgba(251, 255, 0, 0.2);
}

.v-card--link:before {
  background-color: #fff;
}

.stockStyle{
  font-size: 0.85rem;
  font-weight: 400;
  background: #FFF2A9;
  color: #9F8703;
  padding: 4px;
  border-radius: 4px;
  @media (max-width: 500px) {
    font-size: 0.6rem;
  }
}

.discount {
  background: #FFFACC;
  @media (max-width: 800px) {
    background: transparent;
  }
  color: black;
  padding: 3px 10px 0;
  @media (max-width: 500px) {
    padding:0;
  }
  // border-radius: 3px !important;
  font-weight: 500;
}
</style>